// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CitationFileParagraphsQueryVariables = Types.Exact<{
  fileID: Types.Scalars['ID']['input'];
}>;


export type CitationFileParagraphsQuery = { __typename?: 'Query', getFileParagraphs: Array<{ __typename?: 'FileParagraph', id: string, content: string, impliedParagraphNumber: number, boundingRegions: Array<{ __typename?: 'BoundingRegion', PageNumber: number, Polygon: Array<{ __typename?: 'Coordinate', x: number, y: number }> }> }> };

export const Operations = {
  Query: {
    CitationFileParagraphs: 'CitationFileParagraphs' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CitationFileParagraphsDocument = gql`
    query CitationFileParagraphs($fileID: ID!) {
  getFileParagraphs(fileID: $fileID) {
    id
    content
    impliedParagraphNumber
    boundingRegions {
      PageNumber
      Polygon {
        x
        y
      }
    }
  }
}
    `;

/**
 * __useCitationFileParagraphsQuery__
 *
 * To run a query within a React component, call `useCitationFileParagraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitationFileParagraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitationFileParagraphsQuery({
 *   variables: {
 *      fileID: // value for 'fileID'
 *   },
 * });
 */
export function useCitationFileParagraphsQuery(baseOptions: Apollo.QueryHookOptions<CitationFileParagraphsQuery, CitationFileParagraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitationFileParagraphsQuery, CitationFileParagraphsQueryVariables>(CitationFileParagraphsDocument, withFetchPolicyContext(options));
      }
export function useCitationFileParagraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitationFileParagraphsQuery, CitationFileParagraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitationFileParagraphsQuery, CitationFileParagraphsQueryVariables>(CitationFileParagraphsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCitationFileParagraphsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CitationFileParagraphsQuery, CitationFileParagraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CitationFileParagraphsQuery, CitationFileParagraphsQueryVariables>(CitationFileParagraphsDocument, withFetchPolicyContext(options));
        }
export type CitationFileParagraphsQueryHookResult = ReturnType<typeof useCitationFileParagraphsQuery>;
export type CitationFileParagraphsLazyQueryHookResult = ReturnType<typeof useCitationFileParagraphsLazyQuery>;
export type CitationFileParagraphsSuspenseQueryHookResult = ReturnType<typeof useCitationFileParagraphsSuspenseQuery>;
export type CitationFileParagraphsQueryResult = Apollo.QueryResult<CitationFileParagraphsQuery, CitationFileParagraphsQueryVariables>;